import {
  apiRequest,
  pangkatDetail,
  pangkatUpdate,
  pangkatrankGroup,
} from "../../../../../services/adapters/kepegawaian/pangkatService";

class UpdateRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      pangkatDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      pangkatUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchRankGroup = async (query) => {
    return await apiRequest(
      "get",
      pangkatrankGroup,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
